export const registrationFormApiHandler = {
  getRegistrationFormFieldsSort: {
    method: "GET",
    path: () => `organizations-dashboard/registration/sort`
  }
};